/**
 * Newsletter form instant validation
 * Validates email field on blur and submit without page refresh
 */

export default function newsletter_validation() {
    // Target all newsletter forms
    const newsletterForms = document.querySelectorAll('.newsletter-block__form form');

    newsletterForms.forEach(function(form) {
        const emailInput = form.querySelector('input[type="email"]');

        if (!emailInput) return;

        // Validate on blur (when user leaves the field)
        emailInput.addEventListener('blur', function() {
            validateEmailField(emailInput);
        });

        // Validate on submit
        form.addEventListener('submit', function(e) {
            if (!validateEmailField(emailInput)) {
                e.preventDefault();
                return false;
            }
        });
    });

    // Disable Gravity Forms automatic scroll on submission
    window.gform_scroll_to_confirmation = false;

    // Listen for Gravity Forms AJAX success (outside the loop)
    jQuery(document).on('gform_confirmation_loaded', function(event, formId) {

        // Find all newsletter blocks and hide their subheadings
        const newsletterBlocks = document.querySelectorAll('.newsletter-block__content');
        newsletterBlocks.forEach(function(block) {
            // Check if this block contains the confirmed form
            const formWrapper = block.querySelector('.newsletter-block__form');
            if (formWrapper) {
                const confirmationMessage = formWrapper.querySelector('.gform_confirmation_message');
                if (confirmationMessage) {
                    // This is the block with the successful form, hide its subheading
                    const subheading = block.querySelector('.newsletter-block__subheading');
                    if (subheading) {
                        subheading.style.display = 'none';
                    }
                }
            }
        });
    });

    function validateEmailField(input) {
        const value = input.value.trim();
        const field = input.closest('.gfield');

        // Remove existing error
        removeError(field);

        // Check if empty
        if (value === '') {
            showError(field, input, 'This field is required.');
            return false;
        }

        // Check if valid email
        if (!isValidEmail(value)) {
            showError(field, input, 'Please enter a valid email address.');
            return false;
        }

        return true;
    }

    function showError(field, input, message) {
        field.classList.add('gfield_error');
        input.classList.add('gfield_error');

        // Create error message if it doesn't exist
        let errorMessage = field.querySelector('.validation_message');
        if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'validation_message';
            field.appendChild(errorMessage);
        }
        errorMessage.textContent = message;
        errorMessage.style.display = 'block';
    }

    function removeError(field) {
        field.classList.remove('gfield_error');
        const input = field.querySelector('input[type="email"]');
        if (input) {
            input.classList.remove('gfield_error');
        }
        const errorMessage = field.querySelector('.validation_message');
        if (errorMessage) {
            errorMessage.style.display = 'none';
        }
    }

    function isValidEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }
}
